module.exports = __webpack_public_path__ + "img/picto1.251f5c70.svg";